import { render, staticRenderFns } from "./progressbar.vue?vue&type=template&id=52860083&"
import script from "./progressbar.vue?vue&type=script&lang=js&"
export * from "./progressbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports